/** ABC */
const borderRadiusNumeric = {
  /** Used for: Checkboxes, Tooltips, Tags, Chips etc. */
  small: 4,
  /** Used for: TextFields, Buttons etc. */
  medium: 8,
  /** Used for: Modals, Popover etc. */
  large: 12
};

/** ABC */
const borderRadius = {
  /** Used for: Checkboxes, Tooltips, Tags, Chips etc. */
  small: `${borderRadiusNumeric.small}px`,
  /** Used for: TextFields, Buttons etc. */
  medium: `${borderRadiusNumeric.medium}px`,
  /** Used for: Modals, Popover etc. */
  large: `${borderRadiusNumeric.large}px`
};

export { borderRadius, borderRadiusNumeric };
//# sourceMappingURL=border-radius.js.map
